import { NgModule } from '@angular/core';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { CommonModule } from '@angular/common';
import { SiteslistComponent } from './siteslist.component';
import { SitelistRoutingModule } from './sitelist-routing.module';
import { UpdateConfigComponent } from './update-config/update-config.component';
import { SharedModule } from 'src/app/shared.module';


@NgModule({
    declarations: [
        SiteslistComponent, UpdateConfigComponent
    ],
    imports: [
        FormsModule, ReactiveFormsModule,
        CommonModule, SitelistRoutingModule,
        SharedModule
    ],
    exports: [
        SiteslistComponent, UpdateConfigComponent
    ]

})
export class SitelistModule { }
